<template>
  <a-modal
    destroyOnClose
    v-model:open="visible"
    :title="editingId ? $t('l_Edit') : $t('l_Add_rate')"
    :confirm-loading="saving"
    :ok-text="$t('l_Submit')"
    :cancel-text="$t('l_Cancel')"
    @ok="onSave()"
    @cancel="visible = false"
  >
    <div class="rate-form">
      <div style="flex: 1">
        <div class="label">{{ $t("l_Rate_date") }}</div>
        <a-date-picker style="width: 100%" v-model:value="form.rateDate" />
      </div>
      <div style="flex: 1">
        <div class="label">{{ $t("l_Rate_kzt_per_usd") }}</div>
        <a-input-number
          style="width: 100%"
          :min="0"
          :step="0.01"
          v-model:value="form.rate"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { message } from "ant-design-vue";
import { AllApi } from "@/api/all.js";

export default {
  name: "AddEditManualRate",
  emits: ["onSubmit"],
  data() {
    return {
      visible: false,
      saving: false,
      editingId: null,
      form: { rateDate: null, rate: null },
    };
  },
  methods: {
    show() {
      this.editingId = null;
      this.form = { rateDate: this.$dayjs().startOf("day"), rate: null };
      this.visible = true;
    },
    toEdit(record) {
      this.editingId = record.id;
      this.form = {
        rateDate: record.rateDate ? this.$dayjs(record.rateDate) : null,
        rate: record.rate,
      };
      this.visible = true;
    },
    onSave() {
      if (!this.form.rateDate || this.form.rate == null) {
        message.error(this.$t("l_Required_field"));
        return;
      }
      const body = {
        rate: this.form.rate,
        rateDate: Math.round(new Date(this.form.rateDate).getTime()),
      };
      this.saving = true;
      const req = this.editingId
        ? AllApi(
            "reference/manual-exchange-rates/" + this.editingId,
            body,
            "PUT"
          )
        : AllApi("reference/manual-exchange-rates", body, "POST");
      req
        .then((res) => {
          if (res.code == 0 || res.code == 1) {
            message.success(this.$t("l_Succeed"));
            this.visible = false;
            this.$emit("onSubmit", 1);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.rate-form {
  display: flex;
  gap: 12px;
}
.label {
  font-size: 13px;
  margin-bottom: 4px;
  color: #555;
}
</style>
